// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"1cf9161c","320":"02d1b0e3","542":"879b42ee","873":"ab6b3a9f","905":"879b42ee","977":"6cc47cbe"}[chunkId] + ".chunk.css";
};